import React from 'react';
import { Grid } from '@material-ui/core';
import { useState } from 'react';
import { useEffect } from 'react';

const InterimUpload = () => {

    const [url, setUrl] = useState('NONE');

    useEffect(() => {
        setUrl('IMIS REF: ' + window.location.pathname.substr(11));
    }, [])

    return (
        <Grid container spacing={0}>
            <Grid container justify="center">
                <Grid item >
                    <h1>Welkom!</h1>
                </Grid>
            </Grid>
            <Grid container justify="center">
                    <Grid item>
                    <p>Die oplaaifunksionaliteit is nog nie beskikbaar nie. Probeer weer later die bladsy besoek.</p>
                    <p>{url}</p>
                    </Grid>
            </Grid>

        </Grid>

        )

}

export default InterimUpload;


// WEBPACK FOOTER //
// ./src/components/InterimUpload.js